module.exports = __webpack_public_path__ + "top_vloggeri_header.e7ab7439526c891960c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_vloggeri_header.jpg
// module id = 664
// module chunks = 2